import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {SalesWorkflowSteps} from "projects/store/src/app/enums";
import {UtilService} from "library";

@Component({
  selector: 'app-sales-phone-enrollment-manual-retry-message',
  templateUrl: './sales-phone-enrollment-manual-retry-message.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualRetryMessageComponent {
  flowCode: string;
  buttonLoading: boolean = false;
  @Output() step = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter()
  @Input() message!: string;


  constructor(private route: ActivatedRoute, private requestService: RequestService,
              private utilService: UtilService) {
    this.flowCode = this.route.snapshot.params['flow_code'];
  }


  onGotoStep(stepCode: string) {
    this.buttonLoading = this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode: this.flowCode, categoryId: this.requestService.categoryId, stepCode});
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
}
